import React from "react";
import PropTypes from "prop-types";

import DefaultSearch from "core/SiteHeader/DefaultSearch";
import Heading from "core/Heading";
import HeroClickableIcons from "core/HeroClickableIcons";

import { SearchWrapper } from "core/SiteHeader/styles";

import { HeroContainer } from "./styles";

const Hero = ({ title, headingColor }) => {
    return (
        <>
            <HeroContainer>
                <Heading
                    type="h1"
                    size="2xl"
                    bottomSpacing="xl"
                    alignment="center"
                    headingColor={headingColor}
                >
                    {title}
                </Heading>
                <SearchWrapper>
                    <div id="hero-search-wrapper">
                        <DefaultSearch />
                    </div>
                </SearchWrapper>
            </HeroContainer>

            <HeroClickableIcons />
        </>
    );
};

Hero.propTypes = {
    search: PropTypes.object,
    title: PropTypes.string.isRequired,
    headingColor: PropTypes.string
};

export default Hero;
// only instance of this component being used is on HomeNP as of 03/23/2022
